import { PublicClientApplication } from "@azure/msal-browser";

const config = {
    auth: {
        authority: `${process.env.REACT_APP_AUTHORITY}`,
        clientId: `${process.env.REACT_APP_CLIENTID}`,
        redirectUri: `${process.env.REACT_APP_REDIRECTURI}`
    },
    cache: {
        cacheLocation: 'localStorage' as 'localStorage',
        storeAuthStateInCookie: true
    },
    system: {
        tokenRenewalOffsetSeconds: 300
    }
};

// Authentication Parameters
export const loginRequest = {
    //scopes: ['User.Read'],
    scopes: [`api://${process.env.REACT_APP_CLIENTID}/user.read`, `api://${process.env.REACT_APP_CLIENTID}/email`, `api://${process.env.REACT_APP_CLIENTID}/openid`],
    // forceRefresh: true
}
// Options
//   const options = {
//     loginType: LoginType.Redirect,
//     tokenRefreshUri: `${process.env.REACT_APP_REDIRECTURI}`
//   }

export const authProvider = new PublicClientApplication(config)